import { createSlice } from '@reduxjs/toolkit';

import { GameDataLoadingState } from '@/features/game/types';
import { updateGeolocationToken } from '@/features/geolocation-update-token/store/thunks/update-geolocation-token';

export type GeolocationState = {
  loadingState: GameDataLoadingState;
  updateGeolocationResponse?: Record<string, unknown>;
  updateGelocotionError?: Record<string, unknown>;
};

const initialState: GeolocationState = {
  loadingState: GameDataLoadingState.NotStarted,
};

const geolocationUpdateTokenSlice = createSlice({
  name: 'geolocationUpdateToken',
  reducers: {},
  initialState,
  extraReducers: (builder) => {
    builder.addCase(updateGeolocationToken.pending, (state) => {
      state.loadingState = GameDataLoadingState.Loading;
    });
    builder.addCase(updateGeolocationToken.fulfilled, (state, { payload }) => {
      state.loadingState = GameDataLoadingState.Completed;
      state.updateGeolocationResponse = payload;
    });
    builder.addCase(updateGeolocationToken.rejected, (state, action) => {
      state.loadingState = GameDataLoadingState.Failed;
      state.updateGelocotionError = action.payload as Record<string, unknown>;
    });
  },
});

export const geolocationUpdateTokenReducer =
  geolocationUpdateTokenSlice.reducer;
